import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Input from '~~elements/Input';
import Select from '~~elements/Select';
import Button from '~~elements/Button';
import UploadField from '~~elements/UploadField';
import StyledForm from '~~elements/Form';
import toast from '~~elements/Toast';
import { UserResource } from '~~apis/resource';
import { RB_UID_CookieOptions } from '~~commonAPIs/ApiService';
import Cookies from 'js-cookie';
import Multilingual from '../Multilingual';
import { FAVORITE_TEAM_COLOR, FAVORITE_TEAM_TEXT } from '../../../common/definitions/user';

const StyledDiv = styled.div`
  margin-top: 2rem;
`;

const resendEmailText = {
  NONE: '發送驗證信',
  LOADING: '處理中',
  SUCCESS: '成功！請檢查信箱',
  ERROR: '發生錯誤，請稍後重新嘗試',
};

const UserProfile = ({ userInfo }) => {
  const [userData, setUserData] = useState(userInfo);
  const [errorMsg, setErrorMsg] = useState('');
  const [successMsg, setSuccessMsg] = useState('');

  const [resendEmail, setResendEmail] = useState('NONE');

  useEffect(() => {
    setUserData(userInfo);
  }, [userInfo]);

  const handleInputOnchange = (e) => {
    setUserData({
      ...userData,
      [e.target.name]: e.target.value,
    });
  };

  const handleIconUpdate = ({ url, path }) => {
    if (!url || !path) {
      return;
    }

    setUserData({
      ...userData,
      avatar_url: url,
      avatar_path: path,
    });
  };

  const handleIconRemove = (e) => {
    e.preventDefault();
    setUserData({
      ...userData,
      avatar_url: '',
      avatar_path: 'REMOVE',
    });
  };

  const handleIconCancel = (e) => {
    e.preventDefault();
    setUserData({
      ...userData,
      avatar_url: userInfo.avatar_url,
      avatar_path: userInfo.avatar_path,
    });
  };

  const updateProfile = () => {
    UserResource.updateUserInfo(userData)
      .then(({ data }) => {
        Cookies.set('RB_UID', data.RB_UID, RB_UID_CookieOptions);
        toast('更新成功！', { status: 'success', second: 2 });
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((e) => {
        console.log(e);
        toast('更新失敗！請檢查資料或稍候再試', { status: 'error', second: 2 });
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSuccessMsg('');
    setErrorMsg('');
    if (!userData.first_name || !userData.last_name) {
      return setErrorMsg('姓名為必填');
    }

    if (userInfo.user_name === userData.user_name) {
      return updateProfile();
    }

    const userNameReg = /^[a-z0-9][a-z0-9_.]{3,}[a-z0-9]$/;
    if (!userData.user_name.match(userNameReg)) {
      return setErrorMsg('用戶名稱至少5個字元，頭尾需為小寫英文、數字，其餘需為小寫英文、數字與._');
    }
    UserResource.exists({ userName: userData.user_name })
      .then((data) => {
        if (data.data.exists) {
          return setErrorMsg('用戶名稱已被使用');
        }
        return updateProfile();
      })
      .catch(() => {});
  };

  const handleResendEmailVerification = (e) => {
    e.preventDefault();

    setResendEmail('LOADING');
    UserResource.resendEmailVerification()
      .then(() => {
        setResendEmail('SUCCESS');
      })
      .catch(() => {
        setResendEmail('ERROR');
      });
  };

  return (
    <StyledDiv>
      <StyledForm>
        <div className="box">
          {/* 姓名 */}
          <label>姓名</label>
          <div className="input-field --multi-input">
            <div className="input-box">
              <Input
                width="100%"
                placeholder="名"
                name="first_name"
                onChange={handleInputOnchange}
                value={userData.first_name}
              />
              <Input
                width="100%"
                placeholder="姓"
                name="last_name"
                onChange={handleInputOnchange}
                value={userData.last_name}
              />
            </div>
          </div>
          {/* 用戶名稱 */}
          <label>用戶名稱</label>
          <div className="input-field">
            <div className="input-box">
              <Input
                width="100%"
                placeholder="用戶名稱"
                name="user_name"
                onChange={handleInputOnchange}
                value={userData.user_name}
              />
            </div>
          </div>
          <div className="input-field --multi-input">
            <div className="box">
              <label>暱稱</label>
              <Input
                width="100%"
                placeholder="暱稱"
                name="nickname"
                onChange={handleInputOnchange}
                value={userData.nickname}
              />
            </div>
            <div className="box">
              <label
                style={
                  userData.favorite_team
                    ? {
                        backgroundColor: FAVORITE_TEAM_COLOR[userData.favorite_team].split(';')[0],
                        color: FAVORITE_TEAM_COLOR[userData.favorite_team].split(';')[1],
                      }
                    : {}
                }
              >
                支持球隊
              </label>
              <Select
                placeholder="請選擇"
                width="fit-content"
                name="favorite_team"
                value={userData.favorite_team}
                onChange={handleInputOnchange}
              >
                {Object.entries(FAVORITE_TEAM_TEXT).map(([t, text]) => (
                  <option key={t} value={t}>
                    {text}
                  </option>
                ))}
              </Select>
            </div>
          </div>
          <div className="error-msg">{errorMsg}</div>
          <div className="success-msg">{successMsg}</div>
          <Button width="unset" nowrap type="submit" onClick={handleSubmit}>
            更新
          </Button>
          <hr className="divider" />
          {/* 信箱 */}
          <label>
            信箱
            {userData.email_verified ? (
              <label className="success-msg">已驗證</label>
            ) : (
              <label className="error-msg">未驗證</label>
            )}
          </label>
          <div className="input-field">
            <div className="input-box">
              <Input
                width="100%"
                placeholder="信箱"
                name="email"
                onChange={handleInputOnchange}
                value={userData.email}
                disabled
              />
              {!userData.email_verified && (
                <Button
                  mini
                  nowrap
                  width="fit-content"
                  onClick={handleResendEmailVerification}
                  disabled={resendEmail !== 'NONE'}
                >
                  {resendEmailText[resendEmail]}
                </Button>
              )}
            </div>
          </div>
          <hr className="divider" />
          {/* 語言偏好 */}
          <label>
            {Multilingual('USER_PROFILE.LANG_PREFERENCE')}
            <i className="info">{Multilingual('USER_PROFILE.LANG_PREFERENCE_HINT')}</i>
          </label>
          <label>{Multilingual('USER_PROFILE.LANG_PREFERENCE_RESULT')}</label>
        </div>
        <div className="icon">
          {userData.avatar_url ? (
            <img className="icon--pic" src={userData.avatar_url} alt="avatar" />
          ) : (
            <div className="icon--pic default"></div>
          )}
          <div className="icon--box">
            {userData.avatar_url === userInfo.avatar_url ? (
              <>
                <UploadField
                  styleType="box"
                  url="/api/media"
                  customBtn={(onClick) => (
                    <Button mini nowrap width="unset" color="blue" onClick={onClick}>
                      更改
                    </Button>
                  )}
                  onChange={handleIconUpdate}
                />
                <Button mini nowrap width="unset" color="transparent" onClick={handleIconRemove}>
                  移除
                </Button>
              </>
            ) : (
              <Button mini nowrap width="unset" color="transparent" onClick={handleIconCancel}>
                取消
              </Button>
            )}
          </div>
        </div>
      </StyledForm>
    </StyledDiv>
  );
};

export default UserProfile;
